import React from "react";

export const EarthIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  ...props
}) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.9614 3.4171L17.8234 4.17576L15.9267 3.79643L14.7887 3.4171L13.2713 3.79643L12.1333 3.4171L12.892 1.89974H14.4093L15.8963 1.15625C17.0431 1.72335 18.0806 2.48884 18.9614 3.4171Z"
      fill="#03AA6F"
    />
    <path
      d="M10.2388 1.8994L9.85945 3.03743L8.72142 3.41676L7.58339 5.31345L5.68671 6.45148L3.03136 6.83081V7.96884L3.79002 8.7275V10.2449L2.65208 9.48615L1.51405 8.7275L0.854004 6.74358C1.9901 4.0362 4.16183 1.89597 6.88545 0.799316L7.96277 1.52008L10.2388 1.8994Z"
      fill="#03AA6F"
    />
    <path
      d="M11.0005 12.521L10.6212 14.4177L9.10382 15.935V17.073L7.58646 18.211V20.1077L6.44847 19.7284L5.68977 17.8317V14.0383L3.79308 13.659L3.03442 12.1416V11.0036L3.79308 10.245L4.93111 9.10693L5.68977 10.6243H8.34512L9.48315 12.521H11.0005Z"
      fill="#03AA6F"
    />
    <path
      d="M20.5956 5.62833C22.6664 9.3227 22.4305 13.8782 19.9887 17.3384L18.9645 16.3142V14.7969L18.2058 13.2795L17.4471 11.7622V10.2448L16.3091 9.48616L14.7918 9.86548L12.1364 8.72746L11.7571 6.07211L12.8951 4.93408H15.1711L15.9298 6.07211L18.2058 6.45144L20.4818 5.69278L20.5956 5.62833Z"
      fill="#03AA6F"
    />
    <path
      d="M13.2753 3.79648L14.7926 3.41715L15.9307 3.79648L17.8273 4.17581L18.9654 3.41715C19.6007 4.08214 20.1489 4.82524 20.5965 5.62867L20.4827 5.69317L18.2067 6.45183L15.9307 6.0725L15.172 4.93447H12.896L11.758 6.0725L12.1373 8.72784L14.7927 9.86587L16.31 9.48654L17.4481 10.2452V11.7626L18.2067 13.2799L18.9654 14.7973V16.3146L19.9896 17.3388C16.4864 22.3029 9.62227 23.4868 4.65864 19.9836C0.44305 17.008 -1.13842 11.5027 0.855766 6.74393L1.51581 8.72784L2.65384 9.4865L3.79187 10.2452L3.03317 11.0039V12.1419L3.79183 13.6592L5.68851 14.0386V17.832L6.44717 19.7286L7.5852 20.108V18.2113L9.10256 17.0733V15.9352L10.6199 14.4179L10.9992 12.5212H9.48189L8.34386 10.6245H5.68851L4.92986 9.10713L3.79183 10.2452V8.7278L3.03317 7.96919V6.83116L5.68851 6.45183L7.5852 5.3138L8.72323 3.41711L9.86126 3.03778L10.2406 1.89975L7.96457 1.52042L6.88726 0.799663C9.80437 -0.375148 13.0849 -0.245425 15.9003 1.15626L14.4133 1.89975H12.8959L12.1373 3.41711L13.2753 3.79648Z"
      fill="#86DAF1"
    />
  </svg>
);
